module.exports = __webpack_public_path__ + "static/img/ren.1964614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ren.png
// module id = 3B9q
// module chunks = 0